<template>
  <div class="computed-layer smooth-shadow">
    <div
      :class="['layer-header', { active: isActive }]"
      @click="setActiveLayer(data)"
    >
      <i class="material-icons entity-icon">functions</i>
      <div class="flex-col">
        <!-- <p class="caption">Computed Property</p> -->
      </div>
      <input
        :class="['title', 'ellipsis', { disable: !data.isEditable }]"
        v-model="layerName"
        :placeholder="data.name"
      />
      <expand />
      <span class="layer-value">{{ formattedValue || 0 }}</span>
      <icon
        v-if="data.isEditable"
        size="24"
        type="button"
        :class="[
          { rotate: showLayerContents },
          { 'show-on-hover': !showLayerContents },
        ]"
        @click="toggleLayerDetails()"
        >keyboard_arrow_down</icon
      >
    </div>
    <div v-show="showLayerContents" class="layer-contents">
      <p>{{ data.description }}</p>
      <div class="layer-actions">
        <button class="layer-action-button" @click="deleteLayer(data)">
          <Icon size="18">delete</Icon>delete layer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      showLayerContents: false,
    };
  },
  computed: {
    ...mapGetters("LayerManager", ["getActiveLayers"]),
    isActive() {
      if (!(this.getActiveLayers && this.getActiveLayers.length > 0)) {
        return false;
      }

      let activeLayers = this.getActiveLayers
        .filter((item) => item.type === "primary")
        .map((item) => item.id);
      return activeLayers.includes(this.data.id);
    },
    formattedValue() {
      if (!this.data.value) return null;
      let value = parseFloat(this.data.value);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(3), 2);
      return value;
    },
    layerName: {
      get() {
        return this.data.name;
      },
      set(name) {
        this.updateLayer({
          ...this.data,
          name,
        });
      },
    },
  },
  methods: {
    ...mapActions("LayerManager", [
      "updatelayer",
      "deleteLayer",
      "setActiveLayer",
    ]),
    toggleLayerDetails() {
      this.showLayerContents = !this.showLayerContents;
    },
  },
};
</script>

<style lang="scss" scoped>
.computed-layer {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  margin: 5px 10px;

  .layer-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    padding: 10px 15px 10px 10px;

    .show-on-hover {
      display: none;
    }

    .layer-value {
      margin: 0 5px;
    }

    .entity-icon {
      background: var(--border-color);
      border-radius: 50%;
      padding: 10px;
    }

    &:hover {
      cursor: pointer;
      background: var(--color-primary-light);

      .entity-icon {
        color: var(--color-primary);
      }

      .show-on-hover {
        display: flex;
      }
    }

    input.title {
      margin: 0;
      font-weight: bold;
      text-transform: capitalize;
      padding: 12px 10px;
      margin: 0 5px;
      min-width: 0;
      width: auto;
      background: transparent;
      border: 1px solid transparent;
      color: var(--font-color);
      border-radius: 3px;

      &.editable:hover {
        background: var(--color-default-background);
        border: 1px solid var(--color-accent);
      }

      &:focus {
        border: 1px solid var(--color-accent);
      }
    }

    .disable {
      pointer-events: none;
    }

    .caption {
      margin: 0;
      padding: 0 10px 0 15px;
      opacity: 0.6;
    }

    h4 {
      font-size: 1em;
    }

    .rotate {
      transform: rotate(180deg);
    }

    &.active {
      border-left: 3px solid var(--color-primary);
      border-radius: 3px;
      color: var(--color-primary);
      // background: var(--color-primary-light);

      .title {
        color: var(--color-primary);
      }

      .entity-icon {
        background: var(--color-primary);
        color: var(--color-secondary);
      }
    }
  }

  .layer-contents {
    padding: 10px 10px 10px 70px;

    p {
      margin: 0;
    }

    .layer-actions {
      display: flex;
      flex-direction: row;
      padding: 15px 0 0 0;

      .layer-action-button {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 0;
        border-radius: 3px;
        background: var(--color-default-background);
        color: var(--font-color);
        text-transform: capitalize;
        transition: 0.3s all ease-in-out;

        i {
          margin-right: 5px;
        }

        &:hover {
          cursor: pointer;
          color: var(--color-error);
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }
}
</style>
;
